// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"styles_sectionTitle__JxUpP","title":"styles_title__WK2FM","description":"styles_description__V2Gz7"};